<template>
  <div class="data-card">
    <h3 class="mt-0 mb-3">Клиент</h3>
    <el-form :model="form" :rules="rules" ref="form" class="grid-table" :class="[{ 'grid-table_border': !isEdited }]">
      <div class="grid-table__row">
        <p class="text-secondary">ФИО покупателя</p>
        <div>
          <el-form-item v-if="isEdited" prop="clientName">
            <el-input v-model="form.clientName" size="medium" />
          </el-form-item>
          <p v-else>{{ item.clientName }}</p>
        </div>
      </div>
      <div class="grid-table__row">
        <p class="text-secondary">Телефон</p>
        <div>
          <el-form-item v-if="isEdited" prop="clientPhone">
            <el-input v-model="form.clientPhone" size="medium" v-mask="MASKS.PHONE" />
            <input v-show="false" type="text" v-model="form.clientPhone" v-mask="MASKS.PHONE">
          </el-form-item>
          <p v-else>{{ item.clientPhone | VMask(MASKS.PHONE_WRITE) }}</p>
        </div>
      </div>
      <div class="grid-table__row">
        <p class="text-secondary">Доп. телефон</p>
        <div>
          <el-form-item v-if="isEdited" prop="clientAdditionalPhone">
            <el-input v-model="form.clientAdditionalPhone" size="medium" v-mask="MASKS.PHONE" />
            <input v-show="false" type="text" v-model="form.clientAdditionalPhone" v-mask="MASKS.PHONE">
          </el-form-item>
          <p v-else>{{ item.clientAdditionalPhone | VMask(MASKS.PHONE_WRITE)}}</p>
        </div>
      </div>
      <div class="grid-table__row grid-table__row_textarea">
        <p class="text-secondary">Адрес</p>
        <div>
          <el-form-item v-if="isEdited" prop="address">
            <el-input type="textarea" v-model="form.address" size="medium" resize="none" />
          </el-form-item>
          <p v-else>{{ item.address }}</p>
        </div>
      </div>
      <div class="grid-table__row grid-table__row_textarea">
        <p class="text-secondary">Комментарий</p>
        <div>
          <el-form-item v-if="isEdited" prop="comment">
            <el-input type="textarea"
                      v-model="form.comment"
                      :rows="4"
                      maxlength="200"
                      show-word-limit
                      size="medium"
                      resize="none" />
          </el-form-item>
          <p v-else>{{ item.comment }}</p>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import MASKS from '@/commons/constants/masks';

export default {
  props: {
    isEdited: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    form: {
      clientName: '',
      clientPhone: '',
      clientAdditionalPhone: '',
      address: '',
      comment: '',
    },
    rules: {
      clientName: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      clientPhone: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        {
          min: 18, max: 18, message: MESSAGES.INCORRECT_PHONE, trigger: 'blur',
        },
      ],
      clientAdditionalPhone: [
        {
          min: 18, max: 18, message: MESSAGES.INCORRECT_PHONE, trigger: 'blur',
        },
      ],
      address: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'blur' }],
      // comment: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'blur' }],
    },
    MASKS,
  }),
  created() {
    this.fillForm();
  },
  computed: {
    ...mapGetters({
      item: 'orders/item',
    }),
  },
  methods: {
    fillForm() {
      if (this.item) {
        this.form.clientName = this.item.clientName;
        this.form.clientPhone = this.item.clientPhone || '';
        this.form.clientAdditionalPhone = this.item.clientAdditionalPhone || '';
        this.form.address = this.item.address;
        this.form.comment = this.item.comment;
      } else {
        this.form.clientName = '';
        this.form.clientPhone = '';
        this.form.clientAdditionalPhone = '';
        this.form.address = '';
        this.form.comment = '';
      }
    },
    onSave() {
      let isValid = false;
      this.$refs.form.validate((valid) => {
        isValid = valid;
      });
      const form = {
        clientName: this.form.clientName,
        clientPhone: this.form.clientPhone.match(/\d+/g)?.join('').toString(),
        clientAdditionalPhone: this.form.clientAdditionalPhone.match(/\d+/g)?.join('').toString(),
        address: this.form.address,
        comment: this.form.comment,
      };
      return { isValid, form };
    },
  },
  watch: {
    item() {
      this.fillForm();
    },
  },
};
</script>
